(function () {
  'use strict';

  angular
    .module('app.account-user', [])

    .component('accountUpdate', {
      bindings: {
        result: '<',
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountUpdate + '?' + (new Date().getTime());
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$element", "$timeout", "toastr", "HttpService", "AppService", "AccountService", "ModalService", "productsGridService", "CdnService", function ($scope, $rootScope, $element, $timeout, toastr, HttpService, AppService, AccountService, ModalService, productsGridService, CdnService) {
        var ctrl = this,
          unwatch;

        AccountService.initAccount(ctrl);

        var tmpId = 'pg_' + productsGridService.getId();
        $element.find('.addresses').attr('id', tmpId);

        ctrl.formData = {
          RememberMe: false
        };

        AppService.getParams()
          .then(function (params) {
            ctrl.visitor = params.Visitor;
            ctrl.initUserPicture();
          })
          .catch(function (error) {
            console.error(error);
          });

        ctrl.$onInit = function () {
          $scope.device = ctrl.device;
          setShippingAddresses(ctrl.result);
          ctrl.result = null;
        };

        ctrl.$onDestroy = function () {
          if (typeof unwatch !== 'undefined') {
            unwatch();
          }
        };

        ctrl.initUserPicture = function (refresh) {
          refresh = refresh || false;
          AppService.getParams(refresh)
            .then(function (data) {
              if (data.Visitor.IDPicture === 0) {
                ctrl.userPicture = '/img/user-' + (data.Visitor.Title.IDTitle === 'M.' ? 'man' : 'woman') + '.gif';
              } else {
                CdnService.get(data.Visitor.IDPicture, '60x60')
                  .then(function (res) {
                    ctrl.userPicture = res;
                  })
                  .catch(function (err) {
                    console.error(err);
                  });
              }
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.initBirthDate = function (year, month, day) {
          if (day) {
            ctrl.birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
          }
        };

        ctrl.init = function (isPro) {
          ctrl.formData.CustomerPro = isPro === 'True' ? true : false;
          unwatch = $scope.$watch('accountCtrl.formData.CustomerPro', function (value) {
            if (!value) {
              ctrl.formData.IDCompanyTitle = '';
              ctrl.formData.Company = '';
              ctrl.formData.Siret = '';
              ctrl.formData.IDActivity = '';
              ctrl.formData.IDActivityDomain = '';
              ctrl.formData.EUTVANumber = '';
              ctrl.formData.Function = '';
              ctrl.formData.testoon_domaine = '';
              ctrl.formData.testoon_fonction = '';
              ctrl.formData.testoon_type = '';
              $('#IDCompanyTitle').selectpicker('val', '');
              $('#IDActivityDomain').selectpicker('val', '');
            }
            $timeout(function () {
              ctrl.formProfile.$resetValidation();
            });

            $scope.$broadcast('watchResize');
          });
        };

        ctrl.toggleCustomerPro = function (event) {
          if (event.which === 13) {
            event.preventDefault();
            ctrl.formData.CustomerPro = !ctrl.formData.CustomerPro;
          }
        };

        ctrl.submitProfil = function () {
            ctrl.loadingProfile = true;

            if (ctrl.formData.CustomerPro) {
                ctrl.formData.Properties = [
                    {
                        'Key': 'testoon_type',
                        'Values': [ctrl.formData.testoon_type]
                    },
                    {
                        'Key': 'testoon_fonction',
                        'Values': [ctrl.formData.testoon_fonction]
                    },
                    {
                        'Key': 'testoon_domaine',
                        'Values': [ctrl.formData.testoon_domaine]
                    }
                ];
            }

          ctrl.formData.errors = {};

          HttpService.post({
            url: '/AccountUpdateProfile',
            data: ctrl.formData
          })
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  toastr.success('', translate.messages.AccountModified, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                  ctrl.initBirthDate(ctrl.formData.BirthYear, ctrl.formData.BirthMonth, ctrl.formData.BirthDay);
                  ctrl.initUserPicture(true);
                  $rootScope.$broadcast('userUpdate');

                  $timeout(function () {
                    ctrl.formProfile.$resetValidation();
                  }, 400);
                  $scope.$broadcast('toggle_profile');
                } else {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                }
                ctrl.loadingProfile = false;
              });
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.submitAddress = function () {
          var data = {
            IDCard: ctrl.visitor.IDCard,
            Function: '',
            IDTitle: ctrl.visitor.Title.IDTitle,
            FirstName: ctrl.visitor.FirstName,
            LastName: ctrl.visitor.LastName,
            EUTVANumber: ctrl.formData.EUTVANumber,
            Address: ctrl.formData.Address,
            AddressApartment: ctrl.formData.AddressApartment,
            AddressBuilding: ctrl.formData.AddressBuilding,
            AddressLocality: ctrl.formData.AddressLocality,
            PostCode: ctrl.formData.PostCode,
            City: ctrl.formData.City,
            IDCountry: ctrl.formData.IDCountry,
            Phone: ctrl.formData.Phone,
            MobilePhone: ctrl.formData.MobilePhone
          };
          updateAddress(data, ctrl.visitor);
        };

        ctrl.submitShippingAddress = function (address) {
          address.FullName = address.FirstName + ' ' + address.LastName;
          if (address.Company !== '' && address.FirstName !== '' && address.LastName !== '') {
            address.FullName = address.Company + ' (' + address.FirstName + ' ' + address.LastName + ')';
          } else if (address.Company !== '' && address.FirstName === '' && address.LastName !== '') {
            address.FullName = address.Company + ' (' + address.LastName + ')';
          } else if (address.Company !== '' && address.LastName === '') {
            address.FullName = address.Company;
          }

          var data = {
            IDCard: address.IDCard,
            Function: address.Function,
            Company: address.Company || '',
            IDTitle: address.selectTitle || '',
            FirstName: address.FirstName || '',
            LastName: address.LastName || '',
            EUTVANumber: address.EUTVANumber || '',
            Address: address.Address,
            AddressApartment: address.AddressApartment,
            AddressBuilding: address.AddressBuilding,
            AddressLocality: address.AddressLocality,
            PostCode: address.PostCode,
            City: address.City,
            IDCountry: address.selectCountry.IDCountry,
            Phone: address.Phone,
            MobilePhone: address.MobilePhone
          };
          updateAddress(data, address);
        };

        ctrl.removeAddress = function (address) {
          ModalService.show(
            '/Template/Account/ModalRemoveAddressConfirm',
            {
              action: function () {
                removeAddress(address);
              }
            },
            null,
            'modalRemoveAddressConfirmCtrl'
          );
        };

        ctrl.addAddress = function () {
          ModalService.show(
            '/Template/Account/ModalAddAddress',
            {
              titles: ctrl.titles,
              countries: ctrl.countries,
              country: ctrl.visitor.Country,
              action: function () {
                updateShippingAddresses();
              }
            },
            null,
            'modalAddAddressCtrl'
          );
        };

        var n = $element.find('.flip-container').length;
        var i = 0;
        $scope.$on('resized', function () {
          i++;
          if (i === n) {
            ctrl.active = true;
          }
        });

        // Functions

        function updateAddress(data, address) {
          ctrl['loading' + data.IDCard] = true;
          HttpService.post({
            url: '/AccountUpdateAddress',
            data: data
          })
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  toastr.success('', translate.messages.AccountModified, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                  if (data.IDCard === ctrl.visitor.IDCard) {
                    address.Title.IDTitle = data.IDTitle;
                    ctrl.visitor.Country.Designation = response.country;
                    AppService.getParams(true)
                      .then(function (params) {
                        ctrl.visitor = params.Visitor;
                      });
                  } else if (data.Function === '') {
                    updateShippingAddresses();
                    return;
                  } else {
                    address.Title.IDTitle = data.IDTitle;
                    address.Country.Designation = response.country;
                    resizeShippingAddresses();
                  }
                  $timeout(function () {
                    ctrl['formAddress' + data.IDCard].$resetValidation();
                  }, 400);
                  $scope.$broadcast('toggle_address' + data.IDCard);
                } else {
                  _.each(response.errors, function (error) {
                    toastr.warning('', translate.errors[error.Errors[0].ErrorMessage], {
                      allowHtml: true,
                      extraData: {
                        template: 'toast_message.tpl'
                      }
                    });
                  });
                }
                ctrl['loading' + data.IDCard] = false;
              });
          })
          .catch(function (error) {
            console.error(error);
          });
        }

        function removeAddress(address) {
          _.pullAllBy(ctrl.shippingAddresses, [{ IDCard: address.IDCard }], 'IDCard');
          address.Function = '';
          ctrl.submitShippingAddress(address);
        }

        function setShippingAddresses(results) {

          ctrl.shippingAddresses = _.filter(results.addresses, {IDCardType:7});

          ctrl.titles = results.titles;
          ctrl.countries = results.countries;
          _.each(ctrl.shippingAddresses, function (address) {
            address.titles = results.titles;
            address.countries = results.countries;
            $timeout(function () {
              address.selectTitle = address.Title.IDTitle || '';
              address.selectCountry = address.Country;
              ctrl['formAddress' + address.IDCard].$resetValidation();
              $element.find('select.refresh').selectpicker('refresh');
            });
          });
          $timeout(refreshSelects, 1000);
          resizeShippingAddresses();
          $rootScope.$broadcast('showPageLoader', false);
        }

        function updateShippingAddresses() {
          $rootScope.$broadcast('showPageLoader', true);
          ctrl.shippingAddresses = null;
          AccountService.getShippingAddresses()
            .then(function (results) {
              setShippingAddresses(results);
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function resizeShippingAddresses() {
          setTimeout(function () {
            productsGridService.resizeGrid(tmpId, ctrl.device.size, false);
          });
        }

        function refreshSelects() {
          setTimeout(function () {
            $element.find('select.refresh').each(function (index, el) {
              $(el).selectpicker('refresh');
            });
          });
        }

      }],
      controllerAs: 'accountCtrl'
    })

    /* @ngInject */
    .controller('modalRemoveAddressConfirmCtrl', ["data", "device", "options", "ModalService", function (data, device, options, ModalService) {
      var ctrl = this;
      ctrl.submit = function () {
        ModalService.close();
        data.action();
      };
    }])

    /* @ngInject */
    .controller('modalAddAddressCtrl', ["data", "device", "options", "$timeout", "HttpService", "AppService", "ModalService", "toastr", function (data, device, options, $timeout, HttpService, AppService, ModalService, toastr) {
      var ctrl = this;
      ctrl.data = data;

      ctrl.data.Function = '';
      $timeout(function () {
        ctrl.data.selectCountry = ctrl.data.country;
        setTimeout(function () {
          $('.modal').find('select.refresh').selectpicker('refresh');
        });
      });

      var messageTitle;

      ctrl.successMessage = function (title) {
        messageTitle = title;
      };

      ctrl.submit = function () {
        ctrl.loading = true;

        HttpService.post({
          url: '/AccountAddAddress',
          data: {
            Function: ctrl.data.Function,
            IDTitle: ctrl.data.selectTitle || '',
            FirstName: ctrl.data.FirstName || '',
            LastName: ctrl.data.LastName || '',
            EUTVANumber: ctrl.data.EUTVANumber || '',
            Address: ctrl.data.Address || '',
            AddressApartment: ctrl.data.AddressApartment || '',
            AddressBuilding: ctrl.data.AddressBuilding || '',
            AddressLocality: ctrl.data.AddressLocality || '',
            PostCode: ctrl.data.PostCode || '',
            City: ctrl.data.City || '',
            IDCountry: ctrl.data.selectCountry.IDCountry || '',
            Company: ctrl.data.Company || '',
            Phone: ctrl.data.Phone || '',
            MobilePhone: ctrl.data.MobilePhone || ''
          }
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                ModalService.close();
                toastr.success('', messageTitle, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
                ctrl.data.action();
              } else {
                toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

    }])

    .component('accountPasswordReset', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountPasswordReset;
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$timeout", "$location", "toastr", "HttpService", "AppService", "AccountService", "Routes", "DefaultLocalization", function ($scope, $rootScope, $timeout, $location, toastr, HttpService, AppService, AccountService, Routes, DefaultLocalization) {
        var ctrl = this;

        AccountService.initAccount(ctrl);        

        ctrl.$onInit = function () {   
            $scope.device = ctrl.device;
            //console.log(ctrl.device + 'ctrl device');
        }

        // common account end

        ctrl.formData = {
          errors: {}
        };

        ctrl.focus = function () {
          ctrl.formData.errors = {};
        };

        ctrl.submit = function () {

          $rootScope.$broadcast('showPageLoader', true);

          ctrl.formData.errors = {};

          HttpService.post({
            url: AccountService.getLinks().AccountPasswordReset,
            data: ctrl.formData
          })
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                if (response.status === 'OK') {
                  toastr.success('', translate.messages.PasswordModified, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                  $timeout(function () {
                    $location.path('/' + Routes.filter(function (route) { return route.Name === 'AccountHome'; })[0][DefaultLocalization].URL).replace();
                  }, 2000);
                } else {
                  _.each(response.errors, function (error, key) {
                    if (key === 'Global') {
                      ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                    }
                  });
                  $rootScope.$broadcast('showPageLoader', false);
                }
              });
          })
          .catch(function (error) {
            console.error(error);
          });
        };
      }],
      controllerAs: 'accountCtrl'
    })

    /* @ngInject */
    .controller('modalAccountUpdateController', ["$scope", "$rootScope", "$templateCache", "HttpService", "AppService", "AccountService", function ($scope, $rootScope, $templateCache, HttpService, AppService, AccountService) {
      var ctrl = this;
      $rootScope.$broadcast('showPageLoader', false);
      ctrl.links = AccountService.getLinks();

      ctrl.formData = {
        errors: {}
      };

      ctrl.focus = function () {
        ctrl.formData.errors.Global = null;
      };

      ctrl.submit = function () {
        ctrl.loading = true;

        ctrl.formData.errors = {};

        _.replace(ctrl.formData.Phone, / /g, '');
        _.replace(ctrl.formData.MobilePhone, / /g, '');

        HttpService.post({
          url: '/AccountUpdateInvoiceAddress',
          data: ctrl.formData
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                $templateCache.remove(AccountService.getLinks().AccountUpdate);
                AppService.updateParams(response.results);
                $rootScope.$broadcast('invoiceUpdate');
              } else {
                ctrl.loading = false;
                _.each(response.errors, function (error, key) {
                  if (key === 'Global') {
                    ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                  }
                });
              }
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };
    }]);

})();
